import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background-100">
      <a className="skip-link" href="#main-content">本文へ移動</a>
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}